import type { Annotation } from "building-types/annotation/annotationTypes";
import type { Doc } from "building-types/doc";
import type { Table } from "common/data/table";

export function docGetAnnotationLabels(_doc: Doc, annotation: Annotation): Table<boolean> {
  return annotation.labels;
}
